<div class="container-fluid">
  <h2 class="heading">Wanna Add A Quote?</h2>
  <!-- <hr> -->
  <form (ngSubmit)='addQuote() ;quotesForm.resetForm({})' #quotesForm='ngForm'>
      <div class="form-group">
        <label for="name">Enter Your Name</label>
        <input type="text"#name='ngModel' required minlength="3" class="form-control" id="name" [(ngModel)]="quoted.name" name="name"  >
  

          <div *ngIf="name.touched && name.invalid" class="alert alert-danger">
            <p>Name  Is Required</p>
            <div *ngIf="name.errors !== null " >
                <p *ngIf ="name.errors.minlength">  Name of at least 3 characters long.</p>
            </div>
          </div> 
      </div>
     
      <div class="form-group">
        <label for="description">Enter Quote</label>
        <textarea #quote='ngModel'required class="form-control" id="quote" rows="2" required [(ngModel)]="quoted.quote" name="quote" ></textarea>
          <div *ngIf="quote.touched && quote.invalid" class="alert alert-danger">
            <p>Quote Is Required</p>
          </div>
      </div>
      <div class="form-group">
        <label for="name">Enter Quote Author</label>
        <input type="text" #author='ngModel' required class="form-control" id="author"[(ngModel)]="quoted.author" name="author" >
        <div *ngIf="author.touched && author.invalid" class="alert alert-danger">
          <p>Author name  Is Required</p> 
        </div>
      </div>
      <button type="submit" id="btn-submit" class="btn btn-sm ">Submit Quote</button>
  </form>
</div>
